module.exports = __webpack_public_path__ + "static/media/ig.2679dcde.svg";